import type { PropsWithChildren } from "react";

import ApiProvider from "@/providers/Api";
import AuthProvider from "@/providers/Auth";
import PwaProvider from "@/providers/Pwa";
import RouterProvider from "@/providers/Router";
import UiProvider from "@/providers/Ui";
import WhitelabelBrandProvider from "@/providers/WhitelabelBrand";

import "@/providers/i18n";
import "@/providers/dates";

import AnalyticsProvider from "@/providers/Analytics";
import { useCookieBanner } from "@/utils/cookieBanner";

const AppLayerRouter = () => {
  return <RouterProvider />;
};

const AppLayerAuth = ({ children }: PropsWithChildren) => {
  return <AuthProvider>{children}</AuthProvider>;
};

const AppLayerApi = ({ children }: PropsWithChildren) => {
  return <ApiProvider>{children}</ApiProvider>;
};

const AppLayerPwa = ({ children }: PropsWithChildren) => {
  return <PwaProvider>{children}</PwaProvider>;
};

const AppLayerUI = ({ children }: PropsWithChildren) => {
  return <UiProvider>{children}</UiProvider>;
};

const AppLayerWhitelabel = ({ children }: PropsWithChildren) => {
  return <WhitelabelBrandProvider>{children}</WhitelabelBrandProvider>;
};

const AppLayerAnalytics = ({ children }: PropsWithChildren) => {
  return <AnalyticsProvider>{children}</AnalyticsProvider>;
};

const App = () => {
  useCookieBanner();
  return (
    <AppLayerAnalytics>
      <AppLayerWhitelabel>
        <AppLayerUI>
          <AppLayerPwa>
            <AppLayerApi>
              <AppLayerAuth>
                <AppLayerRouter />
              </AppLayerAuth>
            </AppLayerApi>
          </AppLayerPwa>
        </AppLayerUI>
      </AppLayerWhitelabel>
    </AppLayerAnalytics>
  );
};

export default App;
